import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './modules/styles/src/web/shared/index.css';
import './modules/styles/src/web/client/index.css';
import './config/config';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

// Wrap app to help capture errors

ReactDOM.render(
  <BrowserRouter basename="/ClientApp">
    <App />
  </BrowserRouter>,
  document.getElementById('root'),
);
// registerServiceWorker();
